(function () {
  let loadScript = function (url, callback) {
    let script = document.createElement('script');
    script.type = 'text/javascript';

    // If the browser is Internet Explorer.
    if (script.readyState) {
      script.onreadystatechange = function () {
        if (
          script.readyState === 'loaded' ||
          script.readyState === 'complete'
        ) {
          script.onreadystatechange = null;
          callback();
        }
      };
      // For any other browser.
    } else {
      script.onload = function () {
        callback();
      };
    }

    script.src = url;
    document.getElementsByTagName('head')[0].appendChild(script);
  };

  // let initStore = function($) {
  //   removeLocalStorage('postcodes');
  //   removeLocalStorage('products');
  //   removeLocalStorage('areas_and_days');
  //   //get postcodes
  //   let pc_params = { url: '/apps/oa/storefront/get_postcodes' };
  //   let pc_query = $.get(pc_params.url);
  //   pc_query.done(function(data) {
  //     setLocalStorage('postcodes', data);
  //   });
  //   //get current availability
  //   let p_params = { url: '/apps/oa/storefront/get_products' };
  //   let p_query = $.get(p_params.url);
  //   p_query.done(function(data) {
  //     setLocalStorage('products', data);
  //     // todo - populate JP with a nice top bar if sold out for Saturday
  //     // popTopBar();
  //     // todo probably ditch delivery info
  //     // popDeliveryInfo();
  //   });
  //   //get delivery areas and days
  //   let ad_params = { url: '/apps/oa/storefront/get_areas_and_days' };
  //   let ad_query = $.get(ad_params.url);
  //   ad_query.done(function(data) {
  //     setLocalStorage('areas_and_days', data);
  //     // popDeliveryInfo();
  //   });
  // };

  // function popTopBar() {
  //   //only try this is the top bar is present
  //   if ($('.ticker-wrap').length) {
  //     //get delivery areas and days
  //     const pizzas = JSON.parse(getFromLocalStorage('pizzas'));
  //     if (pizzas) {
  //       let dunbarPizzas = '';
  //       let northBerwickPizzas = '';
  //       let haddingtonPizzas = '';
  //       if (
  //         pizzas.hasOwnProperty('success') &&
  //         pizzas.hasOwnProperty('pizza_areas')
  //       ) {
  //         if (parseInt(pizzas.pizza_areas) === 0) {
  //           //no orders yet, so everything up for grabs
  //           dunbarPizzas = 'Available';
  //           northBerwickPizzas = 'Available';
  //           haddingtonPizzas = 'Available';
  //         } else {
  //           dunbarPizzas = !pizzas.pizza_areas.dunbar
  //             ? 'SOLD OUT'
  //             : 'Available';
  //           northBerwickPizzas = !pizzas.pizza_areas.northBerwick
  //             ? 'SOLD OUT'
  //             : 'Available';
  //           haddingtonPizzas = !pizzas.pizza_areas.haddington
  //             ? 'SOLD OUT'
  //             : 'Available';
  //         }
  //       }
  //
  //       $('.ticker__item--dunbar').text(dunbarPizzas);
  //       $('.ticker__item--northBerwick').text(northBerwickPizzas);
  //       $('.ticker__item--haddington').text(haddingtonPizzas);
  //     }
  //   }
  // }

  // function humanDate(m) {
  //   if (moment.isMoment(m)) {
  //     return m.format('ddd Do MMM');
  //   } else {
  //     return 'ERROR';
  //   }
  // }

  /*
  if the delivery info is on page then check to see availability for
  next delivery dates and by areas
   */
  // function popDeliveryInfo() {
  //   if ($('.bb-delivery-info').length) {
  //     const availability = getDeliveryDates();
  //     let html = '';
  //
  //     _.forEach(availability, function(a) {
  //       let soClass = '';
  //       let soText = '';
  //       let naText = '';
  //       let availFrom = '';
  //       if (a.soldOut !== '') {
  //         soClass = 'sold-out';
  //         soText = '<br>SOLD OUT';
  //         availFrom = moment(a.soldOut).subtract(1, 'days');
  //         naText =
  //           'Next delivery date: <span class="avail-date">' +
  //           humanDate(a.nextAvail) +
  //           '</span><br>Order from: <span class="order-date">' +
  //           humanDate(availFrom) +
  //           '</span>';
  //         html +=
  //           '<div class="bb-delivery-row-area">' +
  //           '<div class="bb-delivery-area"><h4>' +
  //           a.area +
  //           '</h4></div>' +
  //           '</div>' +
  //           '<div class="bb-delivery-row-detail">' +
  //           '<div class="bb-area-this">Current delivery: <span class="' +
  //           soClass +
  //           '">' +
  //           humanDate(a.soldOut) +
  //           '</span> ' +
  //           soText +
  //           '</div>' +
  //           '<div class="bb-area-next">' +
  //           naText +
  //           '</div>' +
  //           '</div>';
  //       } else {
  //         html +=
  //           '<div class="bb-delivery-row-area">' +
  //           '<div class="bb-delivery-area"><h4>' +
  //           a.area +
  //           '</h4></div>' +
  //           '</div>' +
  //           '<div class="bb-delivery-row-detail">' +
  //           '<div class="bb-area-this">Current delivery: <span class="current-date">' +
  //           humanDate(a.nextAvail) +
  //           '</span></div>' +
  //           '<div class="bb-area-next">&nbsp;</div>' +
  //           '</div>';
  //       }
  //     });
  //     $('.bb-delivery-info')
  //       .html(html)
  //       .delay(1000)
  //       .slideDown(500);
  //   }
  // }

  /*
   * in this we only care about 'this' coming delivery and the one which follows
   * customers can only book for 'this' one, so the 'next' will always be available
   * in any case, we only check to see that the available days for an area are at
   * least today + 1 for 1 clear day of prep
   */
  // function getDeliveryDates() {
  //   const pizzas = JSON.parse(getFromLocalStorage('pizzas'));
  //   const pcodeData = JSON.parse(getFromLocalStorage('areas_and_days'));
  //   if (pizzas && pcodeData) {
  //     let areaAvailability = {};
  //     _.forEach(pcodeData, function(pca) {
  //       let areaAvailableDate, areaSoldOutDate;
  //       let area = pca.area;
  //       let code = pca.code;
  //       let areaDays = _.split(pca.days, ',');
  //
  //       if (areaDays.length === 1) {
  //         let d = parseInt(_.head(areaDays));
  //         while (moment().add(2, 'days') > moment().day(d)) {
  //           d += 7;
  //         }
  //         let thisDeliveryDay = d;
  //         let nextDeliveryDay = d + 7;
  //         if (pizzas.pizza_areas[code]) {
  //           areaSoldOutDate = null;
  //           areaAvailableDate = moment().day(thisDeliveryDay);
  //         } else {
  //           areaSoldOutDate = moment().day(thisDeliveryDay);
  //           areaAvailableDate = moment().day(nextDeliveryDay);
  //         }
  //       } else {
  //         let possibleDays = [];
  //         _.forEach(areaDays, function(d) {
  //           d = parseInt(d);
  //           while (moment().add(2, 'days') > moment().day(d)) {
  //             d += 7;
  //           }
  //           possibleDays.push(parseInt(d));
  //         });
  //         possibleDays = possibleDays.sort((a, b) => a - b);
  //         if (pizzas.pizza_areas[code]) {
  //           areaSoldOutDate = null;
  //           areaAvailableDate = moment().day(possibleDays[0]);
  //         } else {
  //           areaSoldOutDate = moment().day(possibleDays[0]);
  //           areaAvailableDate = moment().day(possibleDays[1]);
  //         }
  //       }
  //       areaSoldOutDate = moment.isMoment(areaSoldOutDate)
  //         ? areaSoldOutDate
  //         : '';
  //       areaAvailableDate = moment.isMoment(areaAvailableDate)
  //         ? areaAvailableDate
  //         : '';
  //       areaAvailability[code] = {
  //         area: area,
  //         soldOut: areaSoldOutDate,
  //         nextAvail: areaAvailableDate
  //       };
  //     });
  //     return areaAvailability;
  //   } else {
  //     return false;
  //   }
  // }

  function setLocalStorage(key, value) {
    localStorage.setItem(key, value);
  }

  function getFromLocalStorage(key) {
    return localStorage.getItem(key);
  }

  function removeLocalStorage(key) {
    localStorage.removeItem(key);
  }

  const checkLines = (cart) => {
    let hasSat = 0;
    _.forEach(cart.items, function (e) {
      if (e.handle === 'saturday-dinner') {
        hasSat++;
      }
    });
    window.hasSaturdayOnly = hasSat > 0;
  };

  window.initDatepicker = () => {
    const lastHour = window.hasSaturdayOnly === true ? 18 : 23;
    const minDate = moment().hour() >= lastHour ? 2 : 1;
    const maxDate = '+7d';
    $('#date').datepicker('destroy');
    $('#date').datepicker({
      dateFormat: 'dd/mm/yy',
      minDate: minDate,
      maxDate: maxDate,
      beforeShowDay: function (date) {
        const day = moment(date).day();
        let satOnly = true;
        if (window.hasSaturdayOnly === true) {
          satOnly = day === 6;
        }
        return [jp_days.includes(day) && satOnly];
      },
    });
  };

  const vsProgressChange = function ($) {
    $.getJSON('/cart.js', function (cart) {
      checkLines(cart);
      initDatepicker();
    });
    return true;
  };

  if (typeof jQuery === 'undefined' || parseFloat(jQuery.fn.jquery) < 2.2) {
    loadScript(
      '//ajax.googleapis.com/ajax/libs/jquery/2.2.4/jquery.min.js',
      function () {
        jQueryVersion = jQuery.noConflict(true);
        //initStore(jQueryVersion);
      }
    );
  } else {
    jQueryVersion = jQuery;
    //initStore(jQueryVersion);
  }

  var open = window.XMLHttpRequest.prototype.open,
    send = window.XMLHttpRequest.prototype.send,
    onReadyStateChange;

  function openReplacement(method, url, async, user, password) {
    var syncMode = async !== false ? 'async' : 'sync';
    return open.apply(this, arguments);
  }

  function sendReplacement(data) {
    if (this.onreadystatechange) {
      this._onreadystatechange = this.onreadystatechange;
    }
    this.onreadystatechange = onReadyStateChangeReplacement;

    return send.apply(this, arguments);
  }

  function onReadyStateChangeReplacement() {
    if (this.readyState === 4 && this._url === '/cart/change.js') {
      // we only care about cart updates - not anything which
      // other plugins might initiate
      vsProgressChange(jQueryVersion);
    }
    if (this._onreadystatechange) {
      return this._onreadystatechange.apply(this, arguments);
    }
  }

  window.XMLHttpRequest.prototype.open = openReplacement;
  window.XMLHttpRequest.prototype.send = sendReplacement;
})();
